import formatGroupedValues from "../utils/formatGroupedValues";

export const CLIENT_NOTES_SORT_OPTIONS = [{ value: "created", label: "Created" }];

export const CLIENT_NOTES_RELATED_OPTIONS = [
  { value: "field staff", label: "Field staff" },
  { value: "office staff", label: "Office staff" },
  { value: "candidate", label: "Candidate" },
  { value: "outsourced staff", label: "Outsourced staff" },
  { value: "contact client", label: "Contact client" },
];

export const CLIENT_NOTES_DEFAULT_FILTERS = {
  filterCreatedBy: [],
  filterCreatedFrom: "",
  filterCreatedTo: "",
  filterRelatedTo: [],
  showDeleted: false,
  filterSortBy: "created",
  filterSortDirection: "desc",
};

export function buildClientNotesFilterChips(
  {
    filterCreatedBy = [],
    filterCreatedFrom,
    filterCreatedTo,
    filterRelatedTo = [],
    showDeleted,
  },
  { authorOptions = [] } = {},
) {
  const chips = [];
  if (filterCreatedBy.length > 0) {
    const labelFor = (id) => {
      const a = authorOptions.find(
        (o) => String(o.account_id || o.id) === String(id),
      );
      return a
        ? `${a.first_name || ""} ${a.last_name || ""}`.trim() || String(id)
        : String(id);
    };
    chips.push({
      id: "createdBy",
      key: "filterCreatedBy",
      fieldId: "notes-created-by",
      label: `Created by: ${formatGroupedValues(filterCreatedBy, labelFor, 3)}`,
    });
  }
  if (filterCreatedFrom) {
    chips.push({
      id: "createdFrom",
      key: "filterCreatedFrom",
      fieldId: "notes-created-from",
      label: `From: ${filterCreatedFrom}`,
    });
  }
  if (filterCreatedTo) {
    chips.push({
      id: "createdTo",
      key: "filterCreatedTo",
      fieldId: "notes-created-to",
      label: `To: ${filterCreatedTo}`,
    });
  }
  if (filterRelatedTo.length > 0) {
    chips.push({
      id: "related",
      key: "filterRelatedTo",
      fieldId: "notes-related-to",
      label: `Related: ${formatGroupedValues(filterRelatedTo, (v) => v, 3)}`,
    });
  }
  if (showDeleted) {
    chips.push({
      id: "deleted",
      key: "showDeleted",
      fieldId: "notes-show-deleted",
      label: "Show Deleted",
    });
  }
  return chips;
}
